var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"BtnExtend",class:_vm.classList,attrs:{"to":{name: _vm.extend ? 'project-extended' : 'project-beknopt', params: { slug: _vm.slug }}}},[_vm._v("\n  A\n")])}
var staticRenderFns = []

export { render, staticRenderFns }